__turbopack_context__.v({
  "attributeWrapperSidebar": "LeasingVehicleAttributes-module__h8UNCW__attributeWrapperSidebar",
  "contactDisclaimer": "LeasingVehicleAttributes-module__h8UNCW__contactDisclaimer",
  "contactTitle": "LeasingVehicleAttributes-module__h8UNCW__contactTitle",
  "leasingRateWrapper": "LeasingVehicleAttributes-module__h8UNCW__leasingRateWrapper",
  "logo": "LeasingVehicleAttributes-module__h8UNCW__logo",
  "priceWrapper": "LeasingVehicleAttributes-module__h8UNCW__priceWrapper",
});
